import { useCallback } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { RemoveTextStyleIcon } from 'foundations-assets/icons/components/RemoveTextStyleIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const clearMarks = (schema, tr, from, to) => {
  const excludedMarks = ['link'];
  Object.keys(schema.marks).filter(val => !excludedMarks.includes(val)).forEach(mark => {
    if (schema.marks[mark]) {
      tr.removeMark(from, to, schema.marks[mark]);
    }
  });
};
export default function ClearFormatting({
  defaultFontSize,
  defaultFontStyle,
  defaultTextColor
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const clearFormatting = useCallback(e => {
    e.preventDefault();
    const tr = editorState.tr;
    const {
      schema
    } = editorState;
    const {
      from,
      to
    } = tr.selection;
    clearMarks(schema, tr, from, to);
    // Any heading nodes should be replaced with a plain-text node
    editorState.doc.nodesBetween(from, to, (node, pos) => {
      if (node.type === schema.nodes.heading) {
        tr.replaceWith(pos, pos + node.nodeSize, node.content);
        clearMarks(schema, tr, pos, pos + node.nodeSize);
      }
      if (node.type === schema.nodes.list_item) {
        tr.setNodeMarkup(pos, schema.nodes.list_item, null);
      }
    });
    tr.setMeta('font_size', defaultFontSize);
    tr.setMeta('font_style', defaultFontStyle);
    tr.setMeta('text_color', defaultTextColor);
    setEditorState(editorState.apply(tr));
  }, [defaultFontSize, defaultFontStyle, defaultTextColor, editorState, setEditorState]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.clearFormatting"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      "data-test-id": "removeTextStyle",
      onMouseDown: clearFormatting,
      "aria-label": I18n.text('hubspot-prosemirror.tooltips.clearFormatting'),
      selected: false,
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: RemoveTextStyleIcon
      })
    })
  });
}